import { StoreBase } from '@tk/basics/tk.store.base';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StoreMap = Record<string, StoreBase<any>>;

const storeRegistry: StoreMap = {};

export async function configureStore(stores: StoreMap): Promise<void> {
    Object.keys(stores).forEach((key) => {
        storeRegistry[key] = stores[key];
    });

    await Promise.all(Object.values(stores).map((store) => store.startInitialization()));
}

export function useStore<T extends keyof StoreMap>(storeName: T): StoreMap[T] {
    const store = storeRegistry[storeName];
    if (!store) {
        throw new Error(`Store not found: ${storeName}`);
    }
    return store;
}

export async function waitForStore(key: string): Promise<void> {
    const store = storeRegistry[key];
    if (store) {
        return store.isInitialized;
    }
    return Promise.reject(`Store ${key} not found`);
}
